{
    "button": "Settings",
    "group_my_account": "My account",
    "group_organisation": "Organisation",
    "language_label": "Language",
    "default_metric_label": "Metric",
    "default_metric_description": "The default metric shown throughout Plato.",
    "metric_revenue": "Revenue",
    "metric_order_sum": "Order Sum",
    "default_timeframe_label": "Timeframe",
    "default_timeframe_description": "The default timeframe shown throughout Plato.",
    "timeframe_ytd": "Year to date",
    "timeframe_ttm": "Past 12 months"
}
